/**
 *
 * RefrezhStepperConnector
 *
 */

import { makeStyles, withStyles } from "@material-ui/core/styles";
import { StepConnector } from "@material-ui/core";
import clsx from "clsx";
import * as PropTypes from "prop-types";
import CheckSvgIcon from "images/CheckSvgIcon";
// import styled from 'styled-components';

export const RefrezhStepperConnector = withStyles(theme => ({
  alternativeLabel: {
    top: 13,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  line: {
    borderColor: theme.palette.divider,
    borderTopWidth: 2,
    borderRadius: 1,
    width: "95%",
    margin: "0 auto",
  },
}))(StepConnector);

const useRefrezhStepIconStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey["500"],
    color: "#FFF",
    height: 30,
    width: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
  },
  active: {
    backgroundColor: ({ color }) => color,
    color: "#FFF",
  },
  completed: {
    backgroundColor: ({ disabledColor }) => disabledColor,
    color: "#FFF",
    zIndex: 1,
  },
}));

export function RefrezhStepIcon({
  active,
  completed,
  color = "red",
  disabledColor = "red",
  index = 1,
}) {
  const classes = useRefrezhStepIconStyles({
    color,
    disabledColor,
  });

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {completed ? <CheckSvgIcon size={20} /> : <span>{index}</span>}
    </div>
  );
}

RefrezhStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  color: PropTypes.string,
  index: PropTypes.number,
  disabledColor: PropTypes.string,
};
